export default function PopupWindow(props){
    return(
        <div className="fixed top-0 left-0 w-full h-full flex justify-center bg-[#00000090] items-center z-[9999] flex-col" style={{paddingRight:200}}>
            <div className="relative bg-[#E9FFF9] rounded-[20px] shadow-lg p-[8px] w-[90%] md:w-[70%] flex:1 lg:w-[70%] border border-[#000] max-h-[90vh]" style={{border:'8px solid #00E9BA', fontSize:20}}>
                <div className='w-full flex flex-col justify-start items-center rounded-[20px] p-[16px] overflow-y-auto flex-1 max-h-[100%]' style={{border:'4px solid #fff'}}>
                    <div className="mb-4" dangerouslySetInnerHTML={{
                        __html: props.text||''
                    }}></div>
                    <div 
                        onClick={props.onClose} 
                        className="absolute top-[-40px] right-[-40px] cursor-pointer"
                    >
                        <CloseButton/>
                    </div>
                </div>
            </div>
        </div>
    )
}


const CloseButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={70}
      height={70}
      fill="none"
      {...props}
    >
      <rect width={70} height={70} fill="#1F4CC8" rx={10} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={5}
        d="M50.08 18.598 19.768 53.462M51.268 52.367 18.6 19.7"
      />
    </svg>
  )